<p>tabela-padrao works!</p>
<!-- <div class="page-content">
  <div class="search-header">
    <div class="search">
      <svg
        class="svg-search"
        width="20"
        height="20"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.907 17.1479H17.9661L17.6326 16.8263C18.7998 15.4685 19.5025 13.7058 19.5025 11.7883C19.5025 7.51255 16.0366 4.04669 11.7609 4.04669C7.48514 4.04669 4.01929 7.51255 4.01929 11.7883C4.01929 16.064 7.48514 19.5299 11.7609 19.5299C13.6784 19.5299 15.4411 18.8272 16.7989 17.66L17.1205 17.9935V18.9344L23.0755 24.8776L24.8502 23.103L18.907 17.1479ZM11.761 17.1477C8.7954 17.1477 6.40146 14.7537 6.40146 11.7881C6.40146 8.82247 8.7954 6.42853 11.761 6.42853C14.7267 6.42853 17.1206 8.82247 17.1206 11.7881C17.1206 14.7537 14.7267 17.1477 11.761 17.1477Z"
          fill="#84818A"
        />
      </svg>
      <input class="input-search" type="text" placeholder="Pesquisar..." />
    </div>
    <button class="filter-btn">
      <svg
        class="svg-filter"
        width="20"
        height="20"
        viewBox="0 0 34 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.5 19.2192H20V17.1532H14.5V19.2192ZM4.875 6.82306V8.88908H29.625V6.82306H4.875ZM9 14.0542H25.5V11.9881H9V14.0542Z"
          fill="#84818A"
        />
      </svg>
      Filtrar
    </button>
  </div>
  <table>

    <thead >
      <tr class="header-lista">
        <ng-content select="[titulos]">

        </ng-content>

      </tr>
    </thead>


    <div class="lista-funcionarios">
      <tbody class="lista">
          <ng-content select="[linhas]"></ng-content>

        </tbody>
      </div>
  </table>
</div> -->
